import React from 'react'
import Stars from './Stars'
import PacingHeatMaps from './PacingHeatMaps'

export default function Pacing ({stars, byItem, assessmentSubtests}) {
  return (
    <div className="skill-box pacing">
      <div className="skill-information">
        <h1 className="skill-name">Pacing</h1>
        <Stars stars={stars} />
        <p className="skill-description">
          This rating shows the likelihood that students achieved the correct pace for each test segment and were able to consider
          every question on the test. The graphic provides heat maps that show the percentage of students who answered each question
          correctly.
        </p>
		  </div>
      <PacingHeatMaps 
        byItem={byItem}
        assessmentSubtests={assessmentSubtests}
      />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/Pacing.js